module.exports = __webpack_public_path__ + "img/mobile-logo.9ea24423.png";